import { render, staticRenderFns } from "./AttributeEditDialog.vue?vue&type=template&id=2d760320&scoped=true"
import script from "./AttributeEditDialog.vue?vue&type=script&lang=js"
export * from "./AttributeEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d760320",
  null
  
)

export default component.exports